import React from 'react';
import DisclaimerFooter from './DisclaimerFooter';
import SEO from './SEO';

export default function PrivacyPage() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <SEO 
        title="Privacy Policy"
        description="Learn how SharpeMetrix protects your privacy and handles your personal information. Our comprehensive privacy policy explains data collection, usage, and security measures."
        keywords="privacy policy, data protection, personal information, security, SharpeMetrix"
        url="/privacy"
      />
      <div className="bg-bg-100 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold tracking-tight text-text-100 mb-8">Privacy Policy</h1>
        
        <div className="prose prose-invert max-w-none">
          <p className="text-text-200">
            Last Updated: {currentYear}
          </p>
          
          <h2 className="text-2xl font-semibold text-text-100 mt-8 mb-4">Introduction</h2>
          <p className="text-text-200 mb-4">
            SharpeMetrix ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
          </p>
          
          <h2 className="text-2xl font-semibold text-text-100 mt-8 mb-4">Information We Collect</h2>
          <p className="text-text-200 mb-4">
            We may collect information about you in a variety of ways. The information we may collect includes:
          </p>
          <ul className="list-disc pl-6 text-text-200 mb-4">
            <li>Personal Data: Personally identifiable information, such as your name, email address, and telephone number, that you voluntarily provide when registering or using our services.</li>
            <li>Financial Information: Information related to your investment preferences, portfolio data, and other financial details you share when using our services.</li>
            <li>Usage Data: Information about how you use our website and services, including IP address, browser type, pages visited, time spent on pages, and other analytical data.</li>
            <li>Cookies: We use cookies to enhance your experience on our site. You can set your browser to refuse all or some browser cookies, but this may limit your ability to use some features of our site.</li>
          </ul>
          
          <h2 className="text-2xl font-semibold text-text-100 mt-8 mb-4">How We Use Your Information</h2>
          <p className="text-text-200 mb-4">
            Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. We may use information collected about you to:
          </p>
          <ul className="list-disc pl-6 text-text-200 mb-4">
            <li>Create and manage your account</li>
            <li>Provide and deliver the services you request</li>
            <li>Process transactions and send you related information</li>
            <li>Send you technical notices, updates, security alerts, and support messages</li>
            <li>Respond to your comments, questions, and requests</li>
            <li>Personalize your experience and deliver content relevant to your interests</li>
            <li>Monitor and analyze trends, usage, and activities in connection with our services</li>
            <li>Improve our website, products, services, marketing, and user experience</li>
          </ul>
          
          <h2 className="text-2xl font-semibold text-text-100 mt-8 mb-4">Data Security</h2>
          <p className="text-text-200 mb-4">
            We use administrative, technical, and physical security measures to help protect your personal information from unauthorized access, use, or disclosure. However, no website or internet transmission is completely secure, so we cannot guarantee that unauthorized access, hacking, data loss, or other breaches will never occur.
          </p>
          
          <h2 className="text-2xl font-semibold text-text-100 mt-8 mb-4">Third-Party Disclosure</h2>
          <p className="text-text-200 mb-4">
            We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties unless we provide you with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or servicing you, so long as those parties agree to keep this information confidential.
          </p>
          
          <h2 className="text-2xl font-semibold text-text-100 mt-8 mb-4">Changes to This Privacy Policy</h2>
          <p className="text-text-200 mb-4">
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
          </p>
          
          <h2 className="text-2xl font-semibold text-text-100 mt-8 mb-4">Contact Us</h2>
          <p className="text-text-200 mb-4">
            If you have questions or concerns about this Privacy Policy, please contact us at privacy@sharpemetrix.com.
          </p>
        </div>
      </div>
      <DisclaimerFooter />
    </div>
    </>
  );
} 